import overviewIcon from '../assets/context-menu-icons/overview.svg';
import tripsIcon from '../assets/context-menu-icons/trips.svg';
import logbookIcon from '../assets/context-menu-icons/logbook.svg';
import defectsIcon from '../assets/context-menu-icons/defects.svg';
import intermittentIcon from '../assets/context-menu-icons/intermittent-faults.svg';
import cabinIssueIcon from '../assets/context-menu-icons/icon-nav-cabin-issues.svg';
import maintenanceIcon from '../assets/context-menu-icons/maintenance.svg';
import workpacksIcon from '../assets/context-menu-icons/workpacks.svg';
import metricsIcon from '../assets/context-menu-icons/metrics.svg';
import documentsIcon from '../assets/context-menu-icons/documents-2.svg';
import damageMapsIcon from '../assets/context-menu-icons/damage-maps.svg';
import settingsIcon from '../assets/context-menu-icons/settings.svg';
import notesIcon from '../assets/context-menu-icons/icon-navigation-notes-to-crew.svg';
import customFieldsIcon from '../assets/context-menu-icons/icon-nav-custom-fields.svg';
import totpIcon from '../assets/context-menu-icons/totp.svg';

const useAircraftMenuMap = new Map<string, { title: string; icon: string }>([
  ['overview', { title: 'Overview', icon: overviewIcon }],
  ['trips', { title: 'Trips', icon: tripsIcon }],
  ['logbook', { title: 'Logbook', icon: logbookIcon }],
  ['defects/log', { title: 'Defects', icon: defectsIcon }],
  ['intermittent_faults', { title: 'Intermittent Faults', icon: intermittentIcon }],
  ['cabin_log', { title: 'Cabin Log', icon: cabinIssueIcon }],
  ['maintenance', { title: 'Maintenance', icon: maintenanceIcon }],
  ['workpacks/log', { title: 'Workpacks', icon: workpacksIcon }],
  ['documents', { title: 'Documents', icon: documentsIcon }],
  ['dent_and_buckle', { title: 'Dent & Buckle', icon: damageMapsIcon }],
  ['metrics', { title: 'Metrics', icon: metricsIcon }],
  ['notes', { title: 'Notes to Crew', icon: notesIcon }],
  ['custom_fields', { title: 'Custom Fields', icon: customFieldsIcon }],
  ['settings', { title: 'Settings', icon: settingsIcon }],
  ['totp', { title: 'One-Time Password', icon: totpIcon }],
]);

export default useAircraftMenuMap;
